module.exports = __webpack_public_path__ + "0515cdee31e983d93c95d1a6304a6543.pdf";